export const getSubnav = (projectId: string) => (
  [
    { title: 'Audio Stops', to: `/project/${projectId}/stops` },
    { title: 'Audio Tours', to: `/project/${projectId}/tours` },
    { title: 'Mood Journeys', to: `/project/${projectId}/moods` },
    { title: 'Visitor Info', to: `/project/${projectId}/visitor-info` },
  ]
)
